import { connect } from 'react-redux'
import Request from './request'
import { getUser } from '../../../../../stores/user/user.selectors'

const mapStateToProps = (state, { me }) => {
  const user = getUser(state)
  return {
    pendingTeacher:
      user.pending_teacher_type && !user.pending_teacher_type.approved_teacher
  }
}

export default connect(
  mapStateToProps,
  null
)(Request)
